import request from '../../../../api/api';

export default function ShowHistoryEntry(id, type, date) {
    return dispatch => {
        return request(
            '/v1/orders/food/get_orders_by_period' +
            '?object_id=' + id +
            '&object_type=' + type +
            '&period_end=' + date +
            '&period_begin=' + date
        ).then(data => {
                if (data.data.orders && data.data.orders.length > 0) {
                    dispatch({
                        type: 'HISTORY_ACTION',
                        payload: {
                            old: data.data.orders[0].saleTimes,
                            oldDate: data.data.orders[0].orderDate,
                            showOld: true,
                        }
                    })
                }
            },
            error => {
                if (error.data && error.data.returnCode === 0) {
                    dispatch({
                        type: 'HISTORY_ACTION',
                        payload: {
                            old: [],
                            showOld: false,
                            error: error.data.error
                        },
                    });

                    return null;
                } else return Promise.reject(error);
            }
        );
    }
}



/** WEBPACK FOOTER **
 ** ./src/modules/food/actions/history/ShowHistoryEntry.js
 **/